import React from 'react';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import DefaultDrawer from '../defaultDrawer/DefaultDrawer';
import EditSavedPassengerForm from '../../../forms/editSavedPassenger/EditSavedPassengerForm';

function EditSavedPassengerDrawer({
  form, handleSubmit, show, setShow,
}) {
  const { width } = useWindowDimensions();
  return (
    <DefaultDrawer
      show={show && width < 1024}
      setShow={setShow}
      className="edit-profile-drawer"
    >
      <EditSavedPassengerForm
        form={form}
        handleSubmit={handleSubmit}
      />
    </DefaultDrawer>
  );
}

export default EditSavedPassengerDrawer;
